import React from "react";
import { withTranslation } from "react-i18next";
import "./OurInvestments.sass";
import InvestCard from "../../components/InvestCard/InvestCard";
import Persons from "./../Home/persons.png";
import Technology from "./technology.png";
import Cybersec from "./cybersec.png";
import Growth from "./growth.png";
import CyberGlowa from './cyberglowa.png';


class OurInvestments extends React.Component {
  render() {
    const { t } = this.props;
    const isCorporateInfoSection =
      window.location.hostname.includes(process.env.REACT_APP_SUBDOMAIN);

    return (
      <div>
        <h3>{isCorporateInfoSection ? t("ourInvestmentsCorporate") : t("ourInvestments")}</h3>
        <div className="grid--2-1 OurInvestmentsWrapper">
          <InvestCard
            image={Persons}
            alt="Tekst alternatywny"
            title={t(isCorporateInfoSection ? "corporateInvest1Title" : "invest1Title")}
            value="25000 PLN"
            content={t(isCorporateInfoSection ? "corporateInvest1Content" : "invest1Content")}
          />
          <InvestCard
            image={Technology}
            alt="Tekst alternatywny"
            title={t(isCorporateInfoSection ? "corporateInvest2Title" : "invest2Title")}
            value="25000 PLN"
            content={t(isCorporateInfoSection ? "corporateInvest2Content" : "invest2Content")}
          />
          <InvestCard
            image={Cybersec}
            alt="Tekst alternatywny"
            title={t(isCorporateInfoSection ? "corporateInvest3Title" : "invest3Title")}
            value="25000 PLN"
            content={t(isCorporateInfoSection ? "corporateInvest3Content" : "invest3Content")}
          />
          <InvestCard
            image={Growth}
            alt="Tekst alternatywny"
            title={t(isCorporateInfoSection ? "corporateInvest4Title" : "invest4Title")}
            value="25000 PLN"
            content={t(isCorporateInfoSection ? "corporateInvest4Content" : "invest4Content")}
          />
          <InvestCard
            image={CyberGlowa}
            alt="Tekst alternatywny"
            title={t(isCorporateInfoSection ? "corporateInvest5Title" : "invest5Title")}
            value="25000 PLN"
            content={t(isCorporateInfoSection ? "corporateInvest5Content" : "invest5Content")}
          />
        </div>
      </div>
    );
  }
}

export default withTranslation()(OurInvestments);
